var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title",style:({backgroundColor: _vm.bgColor})},[_c('h1',{staticClass:"f-55 regular to-lowercase",style:({color: _vm.titleColor})},[_vm._v(_vm._s(_vm.pageTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }